import React from 'react';
import { useIntl } from 'react-intl';
import translations from 'utils/translations';
import { useDataHelper } from 'utils/dataHelper';

import { theme } from 'theme';
import { styled } from '@material-ui/core/styles';

import { Card, Grid } from '@material-ui/core';
import { breakoutRoomModel } from 'entities/breakoutRoomModel';

import { SdmTypography, SdmSpacer } from '..';

const StyledCard = styled(Card)(({ xsdown }) => ({
  backgroundColor: theme.colors.primary.white,
  borderLeft: `${xsdown ? 5 : 10}px solid ${theme.colors.primary.red}`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: xsdown ? 10 : 20,
  marginBottom: 16,
  borderRadius: 0,
}));

const CustomCard = ({ cardInformations, isXsDown, isSmDown, ...rest }, ref) => {
  const { name, invitations, type, brand } = cardInformations;

  const { getFormattedDate, ellips } = useDataHelper();
  // Hooks
  const intl = useIntl();

  const i18n = translations.personalArea(intl).cards;

  return (
    <StyledCard ref={ref} {...rest} xsdown={isXsDown ? 1 : 0} elevation={0}>
      <Grid container alignItems={'center'}>
        <Grid item xl={5} lg={5} md={6} sm={5} xs={12}>
          <Grid
            container
            alignItems={'flex-start'}
            direction={'column'}
            justify={isXsDown ? 'center' : 'flex-start'}
            style={{ overflow: 'hidden' }}
          >
            <SdmTypography
              variant={isXsDown ? 'h3' : isSmDown ? 'h2' : 'h1'}
              style={{ marginBottom: 0, marginTop: 0 }}
            >
              {ellips(name, 20)}
            </SdmTypography>
            <SdmTypography
              variant={isXsDown ? 'h5' : isSmDown ? 'h4' : 'h3'}
              style={{ marginBottom: 0, marginTop: 0 }}
            >
              {i18n.types[type || breakoutRoomModel.enums.types.BREAKOUT]}
            </SdmTypography>
          </Grid>
        </Grid>
        {isXsDown && <SdmSpacer height={10} />}
        <Grid
          item
          xl={3}
          lg={4}
          md={3}
          sm={7}
          xs={12}
          style={{ marginBottom: isXsDown ? 8 : 0 }}
        >
          <Grid container alignItems={'center'}>
            <Grid item xs={false} sm={1} md={false} lg={1} />
            <Grid item xs={12} sm={6} md={12} lg={6}>
              <SdmTypography
                variant={'text'}
                // margin={0}

                style={{
                  color: theme.colors.primary.grey,
                  marginBottom: 0,
                  marginTop: 0,
                }}
              >
                {getFormattedDate(cardInformations)}
              </SdmTypography>
            </Grid>
            <Grid item xs={12} sm={5} md={12} lg={5}>
              <SdmTypography
                variant={'text'}
                // margin={0}

                style={{
                  color: theme.colors.primary.grey,
                  marginBottom: 0,
                  marginTop: 0,
                }}
              >
                {invitations} {i18n.participants}
              </SdmTypography>
            </Grid>
          </Grid>
        </Grid>
        {isXsDown && <SdmSpacer height={5} />}
        <Grid item xl={4} lg={3} md={3} sm={12} xs={12}>
          <SdmTypography
            variant={'h4'}
            // margin={0}

            style={{
              color: theme.colors.primary.grey,
              marginBottom: 0,
              marginTop: 0,
            }}
          >
            {brand.name
              ? `${i18n.brandLabel}: ${brand.name}`
              : i18n.noBrandLabel}
          </SdmTypography>
        </Grid>
      </Grid>
    </StyledCard>
  );
};

CustomCard.displayName = 'BiggerCardAdmin';

export const BiggerCardAdmin = React.forwardRef(CustomCard);
